import React from 'react'
import BorderBtn from '../Common/BorderBtn'

const ExecutiveSummary = ({title=null , data}) => {
    return (
        <>
            <div className="shadow-md rounded my-4 px-4 py-4">
                <h3 className="uppercase text-lg text-[#1b5df3] font-semibold mb-2 pb-2 border-b-2"><i className='fa fa-file fa-lg text-[#1b5df3]'></i> {title}</h3>
                <p className='text-base'  dangerouslySetInnerHTML={{ __html: data[0]?.executive_summary }} ></p>
                <BorderBtn 
                    customClass="flex justify-center bg-[#1e5df3] w-full mx-auto hover:bg-[#1b5df3] text-white font-semibold py-2 px-6 rounded text-sm"
                    buttonTitle="Contact Us"
                    buttonLink="/contact-us"
                />
            </div>
        </>
    )
}
export default ExecutiveSummary
